import { render, staticRenderFns } from "./InternsEvals.vue?vue&type=template&id=3db48510&scoped=true&"
import script from "./InternsEvals.vue?vue&type=script&lang=js&"
export * from "./InternsEvals.vue?vue&type=script&lang=js&"
import style0 from "./InternsEvals.vue?vue&type=style&index=0&id=3db48510&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db48510",
  null
  
)

export default component.exports